import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/logo-iso-circle.svg'


const _hoisted_1 = { class: "relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-dark-blue" }
const _hoisted_2 = { class: "absolute top-0 right-0 -mr-12 pt-2" }
const _hoisted_3 = { class: "mt-5 flex-1 h-0 overflow-y-auto" }
const _hoisted_4 = { class: "px-2 space-y-1" }
const _hoisted_5 = {
  key: 0,
  class: "ml-2 px-1.5 py-0.5 rounded-full bg-sky-blue text-white text-xs font-semibold"
}
const _hoisted_6 = { class: "hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0" }
const _hoisted_7 = { class: "flex flex-col flex-grow pt-5 bg-nimbus-blue overflow-y-auto" }
const _hoisted_8 = { class: "mt-5 flex-1 flex flex-col" }
const _hoisted_9 = { class: "flex-1 px-2 pb-4 space-y-1" }
const _hoisted_10 = {
  key: 0,
  class: "ml-2 px-1.5 py-0.5 rounded-full bg-sky-blue text-white text-xs font-semibold"
}
const _hoisted_11 = { class: "md:hidden md:pl-64 flex flex-col flex-1 border-b-2" }
const _hoisted_12 = { class: "sticky top-0 z-10 flex-shrink-0 flex items-center h-16 hadow bg-white" }

import { ref } from "vue";

// Icons
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { MenuAlt2Icon } from "@heroicons/vue/outline";
import { XIcon } from "@heroicons/vue/solid";

// Routes
import { routesSidebar } from "@/types/router.type";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSidebar',
  setup(__props) {

const sidebarOpen = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: sidebarOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "fixed inset-0 flex bg-dark-blue z-40 md:hidden",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-dark-blue bg-opacity-75" })
              ]),
              _: 1
            }),
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition ease-in-out duration-300 transform",
              "enter-from": "-translate-x-full",
              "enter-to": "translate-x-0",
              leave: "transition ease-in-out duration-300 transform",
              "leave-from": "translate-x-0",
              "leave-to": "-translate-x-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-in-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in-out duration-300",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
                        }, [
                          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)),
                          _createVNode(_unref(XIcon), {
                            class: "h-6 w-6 text-white",
                            "aria-hidden": "true"
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0 flex items-center px-4" }, [
                    _createElementVNode("img", {
                      class: "h-8 w-auto",
                      src: _imports_0,
                      alt: "Logo Perfit"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("nav", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routesSidebar), (item) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: item.name,
                          to: item.path,
                          class: _normalizeClass([
                    item.name == _ctx.$route.name
                      ? 'bg-dark-blue text-white'
                      : 'text-white hover:bg-sky-blue',
                    'group flex items-center px-2 py-2 text-base font-medium rounded-md',
                  ])
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                              class: "mr-4 flex-shrink-0 h-6 w-6 text-white",
                              "aria-hidden": "true"
                            })),
                            _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                            (item.tag)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.tag), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"]))
                      }), 128)),
                      _createVNode(_component_router_link, { to: "" }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("Test")
                        ])),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createElementVNode("div", {
              class: "flex-shrink-0 w-14",
              "aria-hidden": "true"
            }, null, -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("nav", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routesSidebar), (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.name,
                to: item.path,
                class: _normalizeClass([
                item.name == _ctx.$route.name
                  ? 'bg-dark-blue text-white'
                  : 'text-white hover:bg-dark-blue',
                'group flex items-center px-2 py-2 text-sm font-medium rounded-md',
                item.name === 'Logout' ? 'hidden' : '',
              ])
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                    class: "mr-3 flex-shrink-0 h-6 w-6 text-white",
                    "aria-hidden": "true"
                  })),
                  _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                  (item.tag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.tag), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-inset focus:ring-sky-blue md:hidden",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (sidebarOpen.value = true))
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)),
          _createVNode(_unref(MenuAlt2Icon), {
            class: "h-6 w-6",
            "aria-hidden": "true"
          })
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-dark-blue font-semibold ml-4" }, "Internal Tools", -1))
      ])
    ])
  ]))
}
}

})